<footer id="footer">
  <div class="container-fluid py-2">
    <ul class="nav justify-content-between">
      <li class="nav-item">
        <a data-test-id="contact-us-button" class="nav-link" routerLink="{{ contactUsLink }}">
          {{ 'FOOTER_NAVIGATION_CONTACT_US' | translate }}
        </a>
      </li>
      <li class="nav-item">
        <a data-test-id="donate-button" class="nav-link" routerLink="{{ donateLink }}">
          {{ 'FOOTER_NAVIGATION_DONATE' | translate }}
        </a>
      </li>
      <li class="nav-item">
        <a data-test-id="terms-button" class="nav-link" routerLink="{{ termsLink }}">
          {{ 'FOOTER_NAVIGATION_TERMS' | translate }}
        </a>
      </li>
      <li class="nav-item">
        <a data-test-id="about-us-button" class="nav-link" routerLink="{{ aboutUsLink }}">
          {{ 'FOOTER_NAVIGATION_ABOUT_US' | translate }}
        </a>
      </li>
    </ul>
  </div>
</footer>
